import React from 'react';
import { Settings2 } from 'lucide-react';

/**
 * Shared sub-tabs for Engineering section.
 * Add new tools here as they are built (same pattern as Technical tabs).
 */
export const ENGINEERING_TAB_ITEMS = [
  {
    id: 'coil-configurator',
    label: 'Coil Configurator',
    path: '/engineering',
    icon: <Settings2 size={18} />,
  },
  // Future engineering tools:
  // { id: 'example-tool', label: 'Example Tool', path: '/engineering/example-tool', icon: <...> },
];

/** Routes that belong under the Engineering sidebar section. */
export const ENGINEERING_NAV_PATHS = [
  '/coil-configurator',
  ...ENGINEERING_TAB_ITEMS.map((item) => item.path),
];

export const isEngineeringNavPath = (pathname = '') =>
  ENGINEERING_NAV_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
